import React from 'react';

export default function TermsModal({ isOpen, onClose }) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/40 z-50 flex items-center justify-center overflow-y-auto">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-3xl p-6 max-h-[80vh] overflow-y-auto">
        <h2 className="text-2xl font-bold mb-6">Terms & Conditions</h2>
        <div className="text-gray-700 space-y-6 text-sm leading-relaxed max-h-[65vh] overflow-y-auto pr-2">
          
          <section>
            <h3 className="font-semibold text-base mb-1">1. Overview</h3>
            <p>
              Welcome to <strong>Poppyruz</strong> — a reading platform that allows you to access public domain books, upload your personal reading materials, and customize your reading experience with themes.
              By using Poppyruz, you agree to these Terms and Conditions. If you do not agree, please discontinue use of the service.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">2. Content Access and Uploads</h3>
            <p className="mb-1 font-medium">2.1 Public Domain Content</p>
            <p>
              Poppyruz provides a collection of public domain books that are free to read for all users. These books are accessible to both free and premium users without restrictions.
            </p>
            <p className="mt-2 mb-1 font-medium">2.2 User Uploaded Books</p>
            <p>
              You may upload your own PDF or book files to the platform. These uploads are private, accessible only to you, and are not moderated by Poppyruz. You are responsible for ensuring that you own or have the right to upload the content. Poppyruz assumes no responsibility or ownership over user-uploaded content.
            </p>
            <p className="mt-2 mb-1 font-medium">2.3 User Uploaded Themes</p>
            <p>
              Premium users may upload custom themes (images and audio). These are private and not shared with other users. Poppyruz does not claim rights over user-uploaded themes.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">3. Plans and Limitations</h3>
            <p className="mb-1 font-medium">3.1 Free Tier</p>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Upload up to 4 personal books</li>
              <li>Themes cannot be uploaded</li>
              <li>Limited access to Poppyruz premium themes</li>
              <li>Advertisements will appear during usage</li>
            </ul>
            <p className="mt-2 mb-1 font-medium">3.2 Premium Tier</p>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Unlimited personal book uploads</li>
              <li>Ability to upload custom themes</li>
              <li>Access to all Poppyruz themes</li>
              <li>Ad-free experience</li>
            </ul>
            <p className="mt-2">
              Premium is a one-time payment unless stated otherwise.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">4. Intellectual Property</h3>
            <p>
              Public domain content is free of copyright. Poppyruz’s platform, including its design, branding, and proprietary themes, remain the intellectual property of Poppyruz.
              You may not redistribute or repackage Poppyruz-owned content outside of the platform.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">5. Copyright Infringement</h3>
            <p>
              If you believe content on Poppyruz infringes your rights, please email us at <strong>legal@poppyruz.com</strong> with relevant details. We will review and take appropriate action in compliance with applicable law.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">6. Limitation of Liability</h3>
            <p>
              Poppyruz is provided “as is.” We do not guarantee uninterrupted access or error-free functionality. We are not responsible for any loss, damage, or misuse of content uploaded to or accessed via the platform.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">7. Account Termination</h3>
            <p>
              Poppyruz reserves the right to suspend or terminate accounts that:
            </p>
            <ul className="list-disc list-inside ml-4 space-y-1">
              <li>Violate these terms</li>
              <li>Abuse platform functionality</li>
              <li>Upload unlawful, harmful, or misleading content</li>
            </ul>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">8. Changes to Terms</h3>
            <p>
              We may occasionally update these Terms & Conditions. Continued use of Poppyruz implies your acceptance of the revised terms.
            </p>
          </section>

          <section>
            <h3 className="font-semibold text-base mb-1">9. Contact</h3>
            <p>
              For questions or concerns, reach out at:
            </p>
            <ul className="list-none ml-4">
              <li>📧 mohamedzindha21@gmail.com</li>
            </ul>
          </section>

        </div>
        <div className="text-right mt-6">
          <button
            onClick={onClose}
            className="text-sm text-gray-600 hover:underline"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}
